module.exports = __webpack_public_path__ + "img/service-nongmaodianshang3.4791053d.svg";